import React from "react";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function TSectionCheckBox({ Checked, jsonData, style, Visability, disabled, label, onClick }) {
  const [checked, setChecked] = React.useState(Checked);

  React.useEffect(() => {
    setChecked(Checked);
  }, [Checked]);

  return (
    // <Grid >
    <FormControlLabel
      keyName={jsonData.keyName}
      style={{ whiteSpace: "nowrap", ...style, visibility: Visability, marginLeft: 0 }}
      control={
        <Checkbox
          disabled={disabled}
          keyName={jsonData.keyName}
          style={{ padding: 0 }}
          // defaultChecked={json.Checked === "0" ? false : true}
          checked={checked}
          onChange={(e) => {
            setChecked(!checked);
            onClick(e);
          }}
          sx={{ "& .MuiSvgIcon-root": { fontSize: 17 } }}
        />
      }
      label={label}
    />
    // </Grid>
  );
}
